import React, { useState, useContext, useEffect } from 'react'
import './Popup.css'

import Button from '../../Common/Button/Button'

const Popup = ({ onClose, children, title, noButton, onClickAction, buttonText, buttonColor }) => {


    return (

        <div className='popup__container' >
            <div className='popup__main'>
                <div className='popup__closeBtn' onClick={()=> onClose(false)}></div>
               {title && <div className='popup__title'>{title}</div>}
                <div className='popup__body'>
                   {children}
                   {!noButton && <Button buttonText={buttonText} onClickAction={() => {onClickAction(); onClose(false)}} color={buttonColor} type={'filled'} />}
                </div>
            </div>
        </div>

    )
}
Popup.defaultProps = {
    buttonText: 'Сохранить',
    buttonColor: '#22C532'
}
export default Popup